namespace Shared.Infrastructure

open System

[<RequireQualifiedAccessAttribute>]
module Double =
    let tryParse (str: string) : double option =
        match Double.TryParse(str) with
        | true, n -> Some n
        | _ -> None